import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { TranslationOptions } from '../../types';
import type { TranslationOptionModel } from '../translation-options-model';

@injectable()
export class TranslationOptionModelImpl extends AbstractModel<TranslationOptions> implements TranslationOptionModel {
    protected _modelData: TranslationOptions = [];
}
